import { PEOPLE_SERVICE } from "@/services/people.service.js";
import router from '@/router/index';

const state = { listOutput: {}, personOutput: {}, updateStatusPerson: undefined, updateCredentialsPerson: undefined};

const actions = {
    getList({ dispatch, commit }, inputGetPeople) {
        dispatch('alert/clear', null, { root: true });
        commit('listRequest');
        
        PEOPLE_SERVICE.list(inputGetPeople.pageNumber, inputGetPeople.resultsNumber, inputGetPeople.searchText, inputGetPeople.status, inputGetPeople.orderBy)
            .then(
                output => {
                    commit('listSuccess', output);
                },
                error => {
                    commit('listFailure', error);
                    dispatch('alert/error', error, { root: true });
                }
            );
    },
    editPerson({ dispatch, commit }, inputPerson) {
        dispatch('alert/clear', null, { root: true });
        commit('editRequest');
        PEOPLE_SERVICE.edit(inputPerson.id, inputPerson.person)
            .then(
                output => {
                    commit('editSuccess', output);
                },
                error => {
                    commit('editFailure', error);
                    dispatch('alert/error', error, { root: true });
                }
            );
    },
    addPerson({ dispatch, commit }, inputPerson) {
        dispatch('alert/clear', null, { root: true });
        commit('addRequest');

        PEOPLE_SERVICE.add(inputPerson.person)
            .then(
                output => {
                    commit('addSuccess', output);
                },
                error => {
                    commit('addFailure', error);
                    dispatch('alert/error', error, { root: true });
                }
            );
    },
    getPerson({ dispatch, commit }, personId) {
        dispatch('alert/clear', null, { root: true });
        commit('getRequest');

        PEOPLE_SERVICE.get(personId)
            .then(
                output => {
                    commit('getSuccess', output);
                },
                error => {
                    commit('getFailure', error);
                    dispatch('alert/error', error, { root: true });
                }
            );
    },
    updateStatus({ dispatch, commit }, inputStatus) {
        dispatch('alert/clear', null, { root: true });
        commit('updateStatusRequest');

        PEOPLE_SERVICE.updateStatus(inputStatus.id, inputStatus.status)
            .then(
                output => {
                    commit('updateStatusSuccess', output);
                },
                error => {
                    commit('updateStatusFailure', error);
                    dispatch('alert/error', error, { root: true });
                }
            );
    },
    updateCredentials({ dispatch, commit }, inputCredentials) {
        dispatch('alert/clear', null, { root: true });
        commit('updateCredentialsRequest');

        PEOPLE_SERVICE.updateCredentials(inputCredentials.id, inputCredentials.password, inputCredentials.accessCode)
            .then(
                output => {
                    commit('updateCredentialsSuccess', output);
                },
                error => {
                    commit('updateCredentialsFailure', error);
                    dispatch('alert/error', error, { root: true });
                }
            );
    },
};

const mutations = {
    /* List */
    listRequest(state) {
        //
    },
    listSuccess(state, output) {
        state.listOutput = output;
    },
    listFailure(state) {
        state.listOutput = {};
    },
    /* Add */
    addRequest(state) {
    },
    addSuccess(state) {
        router.push('/pessoas/lista');
    },
    addFailure(state) {
        //
    },
    /* Edit */
    editRequest(state) {
    },
    editSuccess(state) {
        router.push('/pessoas/lista');
    },
    editFailure(state) {
        //
    },
    /* Get */
    getRequest(state) {
        //
    },
    getSuccess(state, output) {
        state.personOutput = output;
    },
    getFailure(state) {
        state.personOutput = {};
    },
    /* Update status */
    updateStatusRequest(state) {
        state.updateStatusPerson = undefined;
    },
    updateStatusSuccess(state) {
        state.updateStatusPerson = true;
    },
    updateStatusFailure(state) {
        state.updateStatusPerson = false;
    },
    /* Update credentials */
    updateCredentialsRequest(state) {
        state.updateCredentialsPerson = undefined;
    },
    updateCredentialsSuccess(state) {
        state.updateCredentialsPerson = true;
    },
    updateCredentialsFailure(state) {
        state.updateCredentialsPerson = false;
    },
};

export const people = {
    namespaced: true,
    state,
    actions,
    mutations
};